import React from "react";
import { Navbar } from "@/components/Navbar";

const CONTENT_WIDTHS = {
  // All application pages start on the same desktop rail. Density belongs to
  // the content inside the frame, not to a different outer page layout.
  form: "max-w-7xl",
  readable: "max-w-7xl",
  content: "max-w-7xl",
  wide: "max-w-7xl",
  canvas: "max-w-7xl",
};

export function AppShell({
  children,
  size = "content",
  tone = "public",
  className = "",
  contentClassName = "",
  innerClassName = "",
  as: Content = "main",
  ...props
}) {
  const background = tone === "workspace" ? "bg-[#121214]" : "bg-[#09090b]";

  return (
    <div className={`min-h-screen ${background} text-white ${className}`} {...props}>
      <Navbar />
      <Content className={`mx-auto w-full ${CONTENT_WIDTHS[size] || CONTENT_WIDTHS.content} px-4 pb-16 pt-24 md:px-6 md:pb-20 ${contentClassName}`}>
        <div className={innerClassName}>{children}</div>
      </Content>
    </div>
  );
}

export function PageIntro({ eyebrow, title, description, icon: Icon, actions, className = "" }) {
  return (
    <header className={`mb-7 flex flex-col gap-4 sm:flex-row sm:items-start sm:justify-between ${className}`}>
      <div className="flex min-w-0 gap-3">
        {Icon && <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-xl bg-[#CCFF00] text-black"><Icon size={22} weight="fill" /></span>}
        <div>
          {eyebrow && <p className="label-tiny text-[#CCFF00]">{eyebrow}</p>}
          <h1 className="mt-1 font-display text-3xl font-black uppercase leading-none tracking-tight text-white sm:text-4xl">{title}</h1>
          {description && <p className="mt-2 max-w-3xl text-sm leading-relaxed text-zinc-400">{description}</p>}
        </div>
      </div>
      {actions && <div className="flex shrink-0 flex-wrap items-center gap-2">{actions}</div>}
    </header>
  );
}

export function Surface({ children, className = "", density = "default", ...props }) {
  const padding = density === "compact" ? "p-4" : "p-5 md:p-6";
  return <section className={`rounded-2xl border border-white/10 bg-[#121214] ${padding} ${className}`} {...props}>{children}</section>;
}
